<template>
  <div>
    <el-dialog
      :title="diatitle"
      :visible.sync="formVisible"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
    >
      <div v-if="formVisible" class="standdialog">
        <LyForm ref="form" />
        <div class="button">
          <el-button @click="formVisible = false" type="danger">取消</el-button>
          <el-button @click="submit" type="primary">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Department from "@/components/Department";
import { addInfo, editInfo, getDetail } from "./api";
const moment = require("moment");
export default {
  name: "Dialog",
  data() {
    return {
      formVisible: false,
      diatitle: "",
      currentId: "",
    };
  },
  computed: {
    formData() {
      return {
        formData: [
          {
            type: "input",
            label: "微信号",
            prop: "weixin",
            defaultVal: "",
            rules: [
              { required: true, message: "请输入微信号", trigger: "blur" },
            ],
          },
          {
            type: "input",
            label: "微信号密码",
            prop: "weixinpasswd",
            defaultVal: "",
          },
          {
            type: "select",
            label: "微信用途",
            prop: "weixin_use",
            options: {
              opts: [
                {
                  label: "企业关联",
                  key: 1,
                },
                {
                  label: "助理号",
                  key: 2,
                },
                {
                  label: "分享",
                  key: 3,
                },
                {
                  label: "老师专线",
                  key: 4,
                },
                {
                  label: "其他",
                  key: 5,
                },
                {
                  label: "未知",
                  key: 0,
                },
              ],
            },
            defaultVal: "",
          },
          {
            type: "select",
            label: "微信来源",
            prop: "weixin_from",
            options: {
              opts: [
                {
                  label: "注册",
                  key: 1,
                },
                {
                  label: "购买",
                  key: 2,
                },
                {
                  label: "未知",
                  key: 0,
                },
              ],
            },
            defaultVal: "",
          },
          {
            type: "date",
            label: "微信注册购买时间",
            prop: "weixin_created_at",
            defaultVal: "",
            options: {
              // type: "date",
            },
          },
          {
            type: "select",
            label: "微信号状态",
            prop: "weixin_status",
            options: {
              opts: [
                {
                  label: "正常",
                  key: 1,
                },
                {
                  label: "短期封号",
                  key: 2,
                },
                {
                  label: "长期封号",
                  key: 3,
                },
                {
                  label: "未知",
                  key: 0,
                },
              ],
            },
            defaultVal: "",
          },
          {
            type: "input",
            label: "微信封号原因",
            prop: "weixin_close_reason",
            defaultVal: "",
          },
          {
            type: "date",
            label: "微信封号时间",
            prop: "weixin_close_time",
            defaultVal: "",
            options: {
              // type: "date",
            },
          },
          {
            type: "input",
            label: "封号天数",
            prop: "weixin_close_days",
            defaultVal: "",
          },
          {
            type: "component",
            label: "使用人",
            prop: "name",
            component: Department,
            rules: [
              { required: true, message: "请选择领用人", trigger: "blur" },
            ],
          },
          {
            type: "date",
            label: "手机卡办理时间",
            prop: "card_created_at",
            defaultVal: "",
            options: {
              // type: "date",
            },
          },
          {
            type: "component",
            label: "办卡人",
            prop: "cardname",
            component: Department,
            rules: [
              { required: true, message: "请选择领用人", trigger: "blur" },
            ],
          },
          // {
          //   type: "input",
          //   label: "办卡人姓名",
          //   prop: "card_realname",
          //   defaultVal: "",
          //   rules: [
          //     { required: true, message: "请输入办卡人姓名", trigger: "blur" },
          //   ],
          // },
          // {
          //   type: "input",
          //   label: "办卡人工号",
          //   prop: "card_uid",
          //   defaultVal: "",
          //   rules: [
          //     { required: true, message: "请输入办卡人工号", trigger: "blur" },
          //   ],
          // },
          {
            type: "input",
            label: "手机号",
            prop: "phone",
            defaultVal: "",
            rules: [
              { required: true, message: "请输入手机号", trigger: "blur" },
            ],
          },
          {
            type: "input",
            label: "ICCID",
            prop: "phone_iccid",
            defaultVal: "",
            rules: [
              { required: true, message: "请输入ICCID", trigger: "blur" },
            ],
          },
          {
            type: "date",
            label: "手机卡发放时间",
            prop: "card_send_time",
            defaultVal: "",
            options: {
              // type: "date",
            },
          },
          {
            type: "select",
            label: "手机卡状态",
            prop: "card_status",
            options: {
              opts: [
                {
                  label: "正常",
                  key: 1,
                },
                {
                  label: "注销",
                  key: 2,
                },
                {
                  label: "未知",
                  key: 0,
                },
              ],
            },
            defaultVal: "",
          },
          {
            type: "textarea",
            label: "备注",
            prop: "remark",
            defaultVal: "",
            options: {
              rows: 3,
            },
          },
        ],
      };
    },
  },
  async mounted() {},
  methods: {
    async add() {
      this.formVisible = true;
      this.diatitle = "新增";
      this.$nextTick(() => {
        this.$refs["form"].init(this.formData);
      });
    },
    async edit(row) {
      this.formVisible = true;
      this.diatitle = "编辑";
      this.currentId = row.id;
      let res = await getDetail({ id: row.id });
      const result = await res.json();
      let { code, data } = result;
      let from = {};
      if (code === 200) {
        from = {
          weixin: data.weixin,
          weixinpasswd: data.weixinpasswd,
          weixin_use: data.weixin_use,
          weixin_from: data.weixin_from,
          weixin_created_at: data.weixin_created_at * 1000,
          weixin_status: data.weixin_status,
          weixin_close_reason: data.weixin_close_reason,
          weixin_close_time: data.weixin_close_time * 1000,
          weixin_close_days: data.weixin_close_days,
          card_created_at: data.card_created_at * 1000,
          phone: data.phone,
          phone_iccid: data.phone_iccid,
          card_send_time: data.card_send_time * 1000,
          card_status: data.card_status,
          remark: data.remark,
          name: {
            person: data.use_user.id,
            dep: data.use_user.dep_id,
          },
          cardname: {
            person: data.card_user.id,
            dep: data.card_user.dep_id,
          },
        };
      }
      this.$nextTick(() => {
        this.$refs["form"].init(this.formData, from);
      });
    },
    async submit() {
      if (this.diatitle === "新增") {
        let data = this.$refs["form"].getData();
        if (data.name) {
          data.uid = data.name.person;
          data.dep_id = data.name.dep;
        }
        if (data.cardname) {
          data.card_uid = data.cardname.person;
        }
        data.weixin_created_at = data.weixin_created_at
          ? moment(data.weixin_created_at).format("YYYY-MM-DD HH:mm:ss")
          : "";
        data.card_created_at = data.card_created_at
          ? moment(data.card_created_at).format("YYYY-MM-DD HH:mm:ss")
          : "";
        data.card_send_time = data.card_send_time
          ? moment(data.card_send_time).format("YYYY-MM-DD HH:mm:ss")
          : "";
        data.weixin_close_time = data.weixin_close_time
          ? moment(data.weixin_close_time).format("YYYY-MM-DD HH:mm:ss")
          : "";
        delete data.name;
        delete data.cardname;
        let res = await addInfo(data);
        const result = await res.json();
        let { code, msg } = result;
        if (code === 200) {
          this.$message.success("添加成功！");
          this.formVisible = false;
          this.$emit("uploaded");
        } else {
          this.$message.error(msg);
        }
      } else {
        let data = this.$refs["form"].getData();
        if (data.name) {
          data.uid = data.name.person;
          data.dep_id = data.name.dep_id;
        }
        if (data.cardname) {
          data.card_uid = data.cardname.person;
        }
        data.weixin_created_at = data.weixin_created_at
          ? moment(data.weixin_created_at).format("YYYY-MM-DD HH:mm:ss")
          : "";
        data.card_created_at = data.card_created_at
          ? moment(data.card_created_at).format("YYYY-MM-DD HH:mm:ss")
          : "";
        data.card_send_time = data.card_send_time
          ? moment(data.card_send_time).format("YYYY-MM-DD HH:mm:ss")
          : "";
        data.weixin_close_time = data.weixin_close_time
          ? moment(data.weixin_close_time).format("YYYY-MM-DD HH:mm:ss")
          : "";
        delete data.name;
        delete data.cardname;
        data.id = this.currentId;
        let res = await editInfo({ id: this.currentId }, data);
        const result = await res.json();
        let { code, msg } = result;
        if (code === 200) {
          this.formVisible = false;
          this.$emit("uploaded");
          this.$message.success("修改成功！");
        } else {
          this.$message.error(msg);
        }
      }
    },
  },
};
</script>
<style lang="scss">
.button {
  display: flex;
  justify-content: center;
}
.standdialog {
  .el-form-item__content {
    margin-bottom: 12px !important;
  }
}
</style>